import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from 'antd-mobile';
function App(props) {
    const { children, ...other } = props;
    return (_jsx(Button, { ...other, color: 'primary', children: children }));
}
export default App;
//# sourceMappingURL=index.js.map